<template>
    <el-button :type="type" :plain="plain" :size="size" v-if="isShow" :icon="icon" :disabled="disabled">
        <slot></slot>
    </el-button>
</template>

<script>
export default {
    name: "BaseButton",
    data() {
        return {
            bSize: 'mini'
        }
    },
    props: {
        rule: '',
        icon: '',
        type: '',
        size: {
            type: String,
            default: 'mini'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        plain: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        size(n, o) {
            this.bSize = n;
        }
    },
    computed: {
        isShow() {
            if(this.rule) {
                return this.$rule.checkRule(this.rule);
            }else{
                return true;
            }
        }
    }
}
</script>
